import { Pipe, PipeTransform } from '@angular/core';
import { Media } from '@models/media/media.model';
import { get } from 'lodash';

@Pipe({
  name: 'gallery',
})
export class GalleryPipe implements PipeTransform {
  transform(gallery: Media[] | undefined, index: number) {
    const unavailable =
      'https://dummyimage.com/200/ebebeb/bdbdbd.jpg?text=Unavailable';
    if (gallery && gallery.length) {
      const media = gallery.at(index);
      if (media) {
        return get(media, 'url', unavailable);
      }
    }
    return unavailable;
  }
}
